import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// ✅ Create a new stock adjustment
export const createStockAdjustment = async (payload) => {
  try {
    const response = await api.post(
      `${API_BASE_URL}api/adjust/stock-adjustments`,
      payload
    );
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to create stock adjustment";
    throw new Error(message);
  }
};

export const getAllStockAdjustments = async () => {
  try {
    const response = await api.get(
      `${API_BASE_URL}api/adjust/stock-adjustments`
    );
    return response.data.data;
  } catch (error) {
    const message =
      error.response?.data?.message || "Failed to fetch stock adjustments";
    const err = new Error(message);
    err.status = error.response?.status;
    throw err;
  }
};

export const updateStockAdjustment = async (id, data) => {
  const response = await api.put(
    `${API_BASE_URL}api/adjust/update/${id}`,
    data
  );
  return response.data;
};

export const deleteStockAdjustment = async (id) => {
  const response = await api.delete(
    `${API_BASE_URL}api/adjust/stock-adjustments/${id}`
  );
  return response.data;
};

// api
export const getStockAdjustmentById = async (id) => {
  const lang = localStorage.getItem("lang") === "ar" ? "ar" : "en";
  const token = localStorage.getItem("token");

  const res = await api.get(
    `${API_BASE_URL}api/adjust/stock-adjustments/${id}/notes`,
    {
      headers: {
        "Accept-Language": lang,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );

  // backend: { success: true, notes: "<string>" }
  return res.data?.notes ?? "";
};
